import type { HTMLAttributes, ReactNode } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import { Text } from '../text';
import css from './upload-dropzone.module.scss';

type UploadDropzoneProps = HTMLAttributes<HTMLDivElement> & {
  icon?: ReactNode;
  hint?: string;
};

export const UploadDropzone = ({
  icon,
  hint,
  className,
  children,
  ...restProps
}: UploadDropzoneProps) => (
  <div className={joinCss(css.root, className)} {...restProps}>
    {icon && <div className={css.icon}>{icon}</div>}
    {children && (
      <Text as="p" size="sm">
        {children}
      </Text>
    )}
    {hint && (
      <Text as="p" variant="muted" size="xs">
        {hint}
      </Text>
    )}
  </div>
);
